//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    figureData: {
      default: () => {
        return {
          startFoot: "No data",
          endFoot: "No data",
        };
      },
    },
  },
  data() {
    return {
      editMode: false,
      newData: null,
      showJSON: false,
      stepfields: [
        "movement",
        "turn",
        "alignment",
        "moving",
        "timing",
        "position",
        "risefall",
        "sway",
        "footwork",
      ],
    };
  },
  computed: {
    newManStep() {
      return {
        step: this.newData.stepsMan.length + 1,
        movement: null,
        turn: null,
        alignment: null,
        moving: null,
        timing: null,
        position: null,
        risefall: null,
        sway: null,
        footwork: null,
      };
    },
    newLadyStep() {
      return {
        step: this.newData.stepsLady.length + 1,
        movement: null,
        turn: null,
        alignment: null,
        moving: null,
        timing: null,
        position: null,
        risefall: null,
        sway: null,
        footwork: null,
      };
    },
  },
  watch: {
    figureData() {
      this.newData = this.figureData;
      if (!("stepsMan" in this.newData)) {
        this.newData = { ...this.newData, ...{ stepsMan: [] } };
      }
      if (!("stepsLady" in this.newData)) {
        this.newData = { ...this.newData, ...{ stepsLady: [] } };
      }
    },
  },
  methods: {
    save() {
      this.editMode = false;
      this.$emit("save", this.newData);
    },
  },
};
